export const getShortLabel = (label: string, maxChars: number) => {
  if (label?.length >= maxChars)
    return label?.slice(0, maxChars)?.concat('...');
  else return label;
};
